// extracted by mini-css-extract-plugin
module.exports = {"search":"DataRoom_search__3SAf5"};